import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-services',
  templateUrl: './home-services.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./home-services.component.scss']
})
export class HomeServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
